export const DRAWER_PATIENT_INFO_WIDTH = '63px';
